import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ContractService } from './../base/contract';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { PremisesContract } from '../../model/premises-contract';
import { Observable } from 'rxjs';
import { Contract } from '../../model/contract';
import { PropertyTaxRentalChangeModel } from '../../model/property-tax-rental-change';

export interface PremisesDraftPropertyTaxCalculationRequest {
  propertyId: string;
  rentalObjectId: string;
  leaseAgreementId?: string | null;
  propertyTaxPayer: number;
  propertyTaxCalculationBasis?: number | null;
  propertyTaxPercentage?: number | null;
  propertyTaxCalculationMethod?: number | null;
  propertyTaxArticleId?: string | null;
  propertyTaxRetroactiveArticleId?: string | null;
}

@Injectable()
export class PremisesContractService extends ContractService<PremisesContract> {
  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, PremisesContract, progressBar, 'premises-agreement', 'Lokalkontrakt.xlsx');
  }

  retrieveUpdatedLeaseAgreementPremises(contract: Contract): Observable<any> {
    return this.client.patch(`${this.endpoint}/get-updated-premises`, contract);
  }

  calculateDraftPropertyTax(request: PremisesDraftPropertyTaxCalculationRequest): Observable<PropertyTaxRentalChangeModel | null> {
    return this.client.post<PropertyTaxRentalChangeModel | null>(`${this.endpoint}/draft-property-tax-change`, request);
  }
}
